import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../Utils/Utils";
import axios from "axios";
import { Form, Modal, Button } from "react-bootstrap";

export default function AddLocationModal(props) {
  const [name, setName] = useState("");
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    const url =
      process.env.REACT_APP_SOPHYAPP_API_URL +
      `/de/react/${getAccessToken()}/settings/add_location`;
    var params = new FormData();
    params.append("name", name);
    axios
      .post(url, params)
      .then(function (response) {
        props.setLocations([...props.locations, response.data]);
      })
      .catch(function () {
        alert("Etwas ist schiefgelaufen!");
      });
    props.onHide();
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("settings.locationsHeader")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("settings.locationName")}</Form.Label>
            <Form.Control
              type="text"
              placeholder="Kufstein"
              value={name}
              required
              autoFocus
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("profile.save")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
